import * as React from 'react'
import { Col, Row } from 'react-bootstrap'

interface ISubHeaderProps {
  label: string
}

export class SubHeader extends React.Component<ISubHeaderProps, {}> {
  constructor(props) {
    super(props)
  }

  render() {
    const { label } = this.props
    return (
      <Row style={{ marginTop: '1.0rem' }}>
        <Col sm={12}>
          <header className="text-center" style={{ backgroundColor: '#BDD7EE', padding: '10px' }}>
            <h4>{label}</h4>
          </header>
        </Col>
      </Row>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/tabs/SubHeader/index.tsx